import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
export function TomosSection() {
  const tomo1 = ['Herramientas y materiales', 'Cómo usar la aguja correctamente', 'Tipos de telas', 'Técnicas básicas', 'Cambio de colores', 'Terminaciones prolijas', 'Primeros proyectos'];
  const tomo2 = ['Productos que más se venden', 'Cómo calcular precios', 'Cómo conseguir clientes', 'Fotografía para ventas', 'Redes sociales', 'Catálogo digital', 'Marca propia'];
  const includes = ['Lista completa de materiales', 'Paso a paso explicado simple', 'Técnicas para principiantes', 'Diseños fáciles de realizar', 'Métodos profesionales', 'Estrategias para vender desde casa'];
  return <section className="py-8 md:py-12 px-4 max-w-5xl mx-auto" data-id="element-286">
      <div className="grid md:grid-cols-2 gap-5 mb-8" data-id="element-287">
        {/* Tomo 1 Card */}
        <div className="bg-white rounded-2xl p-5 md:p-6 shadow-soft border-t-4 border-t-brand-pink relative" data-id="element-288">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 text-4xl" data-id="element-289">
            📘
          </div>
          <h3 className="font-heading text-xl font-bold text-center text-brand-dark mt-3 mb-1" data-id="element-290">
            TOMO 1 — EL MÉTODO ARTE BORDADO™
          </h3>
          <p className="text-center text-brand-text mb-4 font-medium text-sm" data-id="element-291">
            Aprendé Punch Needle desde cero.
          </p>
          <ul className="space-y-2" data-id="element-292">
            {tomo1.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-293">
                <CheckCircleIcon className="text-brand-pink mt-0.5 shrink-0" fontSize="small" data-id="element-294" />
                <span className="text-brand-dark text-sm md:text-base" data-id="element-295">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Tomo 2 Card */}
        <div className="bg-white rounded-2xl p-5 md:p-6 shadow-soft border-t-4 border-t-brand-purple relative" data-id="element-296">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 text-4xl" data-id="element-297">
            📙
          </div>
          <h3 className="font-heading text-xl font-bold text-center text-brand-dark mt-3 mb-1" data-id="element-298">
            TOMO 2 — DE HOBBY A NEGOCIO
          </h3>
          <p className="text-center text-brand-text mb-4 font-medium text-sm" data-id="element-299">
            Cómo transformar tus creaciones en ingresos.
          </p>
          <ul className="space-y-2" data-id="element-300">
            {tomo2.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-301">
                <CheckCircleIcon className="text-brand-purple mt-0.5 shrink-0" fontSize="small" data-id="element-302" />
                <span className="text-brand-dark text-sm md:text-base" data-id="element-303">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="bg-brand-cream rounded-2xl p-5 md:p-8 border border-brand-pink/20" data-id="element-304">
        <h3 className="font-heading text-xl md:text-2xl font-bold text-center text-brand-dark mb-5" data-id="element-305">
          ¿QUÉ INCLUYE CADA TOMO?
        </h3>
        <div className="grid sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-306">
          {includes.map((item, i) => <div key={i} className="flex items-center gap-2 bg-white p-3 rounded-xl shadow-sm" data-id="element-307">
              <CheckIcon className="text-green-500 shrink-0" fontSize="small" data-id="element-308" />
              <span className="font-medium text-brand-dark text-sm md:text-base" data-id="element-309">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}